module.exports = __webpack_public_path__ + "static/media/Man.6a67576b.svg";